import {
  BatchExportDocumentReference,
  BatchJobExecutionDetails,
  ColumnSpecification,
} from '@rygen/rygen-ui/model';

import { OrderSearchCriteria, OrderSearchExportCriteria } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order/query';

export class OrderSearchController extends BaseHttpController {
  constructor() {
    super(endpoint, { useSelectedDomainContext: true });
  }

  async export(
    query: OrderSearchCriteria,
    columns: ColumnSpecification[],
  ): Promise<BatchJobExecutionDetails> {
    const searchExportCriteria = new OrderSearchExportCriteria({
      query: query,
      visibleColumns: columns.map((col) => col.field),
    });

    const response = await this.http.post<BatchJobExecutionDetails>(
      'export',
      searchExportCriteria,
    );
    return new BatchJobExecutionDetails(response.data);
  }

  async getJobStatus(jobId: number): Promise<BatchJobExecutionDetails> {
    const response = await this.http.get<BatchJobExecutionDetails>(
      `export/job/${jobId}`,
    );
    return new BatchJobExecutionDetails(response.data);
  }

  async getDocument(jobId: number): Promise<BatchExportDocumentReference> {
    const response = await this.http.get<BatchExportDocumentReference>(
      `export/job/${jobId}/document`,
    );
    return new BatchExportDocumentReference(response.data);
  }
}
